/**
 * TTP Agent SDK - Main Entry Point
 * 
 * A comprehensive SDK for voice and text interaction with AI agents.
 * Provides real-time audio recording, WebSocket communication, and audio playback.
 */

// Core SDK
import VoiceSDK_v2 from './v2/VoiceSDK.js';

// Backward-compatible alias: the legacy `VoiceSDK` name (v1) now points at the
// v2 implementation. The v2 class defaults to `protocolVersion: 2`, so existing
// code and documentation that references `VoiceSDK` keeps working on v2.
const VoiceSDK = VoiceSDK_v2;
import TextChatSDK from './core/TextChatSDK.js';
import WebSocketManager from './core/WebSocketManager.js';
import AudioRecorder from './core/AudioRecorder.js';
import AudioPlayer from './core/AudioPlayer.js';
import EventEmitter from './core/EventEmitter.js';

// Widgets
import { TTPChatWidget } from './widget/TTPChatWidget.js';
import { TTPEcommerceWidget } from './ecommerce/TTPEcommerceWidget.js';
import { ItemCard } from './widget/ItemCard.js';
import { GalleryViewer } from './widget/GalleryViewer.js';
import { FlyToCart } from './ecommerce/FlyToCart.js';
import { useFlyToCart } from './ecommerce/useFlyToCart.js';

// Internal (used by widgets)
import { AgentSDK } from './widget/AgentSDK.js';

// Microphone Permission Utilities
import * as MicPermissionUtils from './shared/MicPermissionUtils.js';
import * as MicPermissionModals from './shared/MicPermissionModals.js';

// Version - injected at build time from package.json via webpack DefinePlugin
export const VERSION = __SDK_VERSION__;
export const BUILD_TIME = __BUILD_TIME__;

console.log(`%c TTP Agent SDK v${VERSION} (${BUILD_TIME}) `, 'background: #4f46e5; color: white; font-size: 12px; font-weight: bold; padding: 2px 6px; border-radius: 4px;');

// Named exports
export {
  VoiceSDK_v2,
  VoiceSDK,
  TextChatSDK,
  WebSocketManager,
  AudioRecorder,
  AudioPlayer,
  EventEmitter,
  AgentSDK,
  TTPChatWidget,
  TTPEcommerceWidget,
  ItemCard,
  GalleryViewer,
  FlyToCart,
  useFlyToCart,
  MicPermissionUtils,
  MicPermissionModals
};

// Default export
export default {
  VoiceSDK_v2,
  VoiceSDK,
  TextChatSDK,
  WebSocketManager,
  AudioRecorder,
  AudioPlayer,
  EventEmitter,
  AgentSDK,
  TTPChatWidget,
  TTPEcommerceWidget,
  ItemCard,
  GalleryViewer,
  FlyToCart,
  useFlyToCart,
  VERSION
};
